import Quill from 'quill';

import { environment } from '../../../environments/environment';

const BaseLink: any = Quill.import('formats/link');

export class CustomQuillLink extends BaseLink {

    static sanitize(url: string): string {
        const allowedProtocols = /^(https?:\/\/|mailto:|tel:)/i;

        if (allowedProtocols.test(url)) return url;
        return 'https://' + url;
    }

    static create(value: string) {
        const sanitized = this.sanitize(value);

        let node = super.create(sanitized);
        // value = this.sanitize(value);
        node.setAttribute('href', sanitized);
        if (sanitized.toLowerCase().startsWith(environment.staffToolUrl.toLowerCase())) {
            node.removeAttribute('target');
        }
        return node;
    }
}